import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { TailSpin } from "react-loader-spinner";
import { toast } from "react-hot-toast";
import { API_URL } from "../constant";
import axiosInstance from "../utils/axiosConfig";
import { getDeviceInfo } from "../utils/deviceInfo";
import { validateLoginDetails } from "../utils/validteDeets";

const LoginWithEmail = ({ setOtpScreen, setOtpPayload }: any) => {
  const [email, setEmail] = useState("");
  const [viewPassword, setViewPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const deviceInformation = getDeviceInfo();

  // 🔹 Step 2: Normal login
  const signIn = async (email: string, password: string, deviceInfo: any) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(`${API_URL}api/auth/signin`, {
        email,
        password,
        deviceInfo: {
          name: deviceInfo.deviceName,
          uniqueId: deviceInfo.uniqueId,
          os: deviceInfo.operatingSystem?.family,
        },
        rolePass: "admin",
        "2faMethod": "email",
      });

      setOtpScreen(true);
      setOtpPayload({
        email,
        password,
        deviceInfo: {
          name: deviceInfo.deviceName,
          uniqueId: deviceInfo.uniqueId,
          os: deviceInfo.operatingSystem?.family,
        },
      });
    } catch (error: any) {
      toast.error(
        (error?.response?.data?.message as string) ||
          String(error?.message || "Login failed")
      );
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Step 3: Login with 2FA

  // 🔹 Step 4: Handle form submission
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validateLoginDetails(email, password)) return;
    signIn(email, password, deviceInformation);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="lgss:mt-12 mt-12 md:mt-0   w-full "
    >
      <div className="w-full">
        <label className="text-white font-bold text-[14px]">Email</label>
        <input
          type="email"
          value={email}
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value.toLowerCase())}
          name="email"
          className="h-[58px] w-full mt-4  px-[16px]  font-manrope border-2 rounded-lg border-gray-500 outline-none bg-transparent  text-[#A0A9AD] transition duration-200"
        />
      </div>
      <div className="mt-8">
        <h4 className="text-white text-[15px] font-medium">Password</h4>
        <label className="relative  flex items-center ">
          <input
            type={viewPassword ? "text" : "password"}
            value={password}
            placeholder="Enter your password"
            onChange={(e) => setPassword(e.target.value)}
            name="password"
            className="h-[58px] w-full mt-4  px-[16px]  font-manrope border-2 rounded-lg border-gray-500 outline-none bg-transparent  text-[#A0A9AD] transition duration-200"
          />

          {!viewPassword ? (
            <AiOutlineEyeInvisible
              className="text-xl -ml-10 mt-[16px] text-gray-500"
              onClick={() => setViewPassword((prev) => !prev)}
            />
          ) : (
            <AiOutlineEye
              className="text-xl -ml-10 mt-[16px] text-gray-500"
              onClick={() => setViewPassword((prev) => !prev)}
            />
          )}
        </label>
      </div>
      <button
        type="submit"
        disabled={loading}
        className="w-full h-[63px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-12"
      >
        {loading ? (
          <TailSpin color="#FFFFFF" height={30} width={30} />
        ) : (
          "Login"
        )}
      </button>
    </form>
  );
};

export default LoginWithEmail;
